// extracted by mini-css-extract-plugin
module.exports = {"navButton":"Header_navButton__4TA5e"};